import { Download } from "lucide-react";
import { money } from "@/lib/api";

export const ROLE_NAME = { sales_manager: "Sales Manager", sales_agent: "Sales Force", cashier: "Cashier (locked)", admin: "Admin", super_admin: "Super Admin" };

export const currentPeriod = () => {
  const p = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Manila", year: "numeric", month: "2-digit" }).format(new Date());
  return p.slice(0, 7);
};

export function downloadCsv(name, rows) {
  if (!rows.length) return;
  const cols = Object.keys(rows[0]);
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [cols.join(","), ...rows.map((r) => cols.map((c) => esc(r[c])).join(","))].join("\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  a.download = name;
  a.click();
}

export const CsvButton = ({ name, rows, testId = "export-csv-button" }) => (
  <button className="btn-secondary btn-sm" disabled={!rows?.length} onClick={() => downloadCsv(name, rows)} data-testid={testId}><Download size={13} /> Export CSV</button>
);

export const PeriodPicker = ({ value, onChange }) => (
  <input type="month" className="field w-44" value={value} onChange={(e) => onChange(e.target.value || currentPeriod())} data-testid="period-picker" />
);

export function Progress({ label, p, testId }) {
  const pct = p.pct_amount ?? 0;
  return (
    <div className="surface p-5" data-testid={testId}>
      <div className="flex items-baseline justify-between gap-2">
        <p className="label">{label}</p>
        <p className="text-2xl font-extrabold text-gradient" data-testid={`${testId}-pct`}>{p.pct_amount == null ? "—" : `${p.pct_amount}%`}</p>
      </div>
      <p className="mt-1 text-lg font-bold">{money(p.achieved_amount)} <span className="text-sm font-medium text-slate-400">/ {money(p.target_amount)}</span></p>
      <div className="mt-3 h-3 overflow-hidden rounded-full bg-slate-100"><div className="h-full rounded-full gradient-brand transition-[width] duration-700" style={{ width: `${Math.min(pct, 100)}%` }} /></div>
      <p className="mt-2 text-xs text-slate-500">
        {p.achieved_count} / {p.target_count} memberships
        {p.target_amount > 0 && <> · <b className="text-slate-700">{money(p.to_go_amount)} to go</b> / {p.to_go_count} memberships to go</>}
        {!p.target_amount && !p.target_count && " · no target set"}
      </p>
    </div>
  );
}

export const Stat = ({ label, value, sub, testId }) => (
  <div className="surface p-5" data-testid={testId}>
    <p className="label">{label}</p>
    <p className="mt-1 text-2xl font-extrabold text-slate-900">{value}</p>
    {sub && <p className="text-xs text-slate-500">{sub}</p>}
  </div>
);
